<div class="bg-primary state-container border">
  <div class="inner-box d-flex flex-column align-items-center justify-content-center">
    <div class="connection-state d-flex align-items-center w-100">
      <div class="logo flex-shrink-0">
        <img ngSrc="assets/logos/logo-gitlab--white.svg" class="icon-white" height="50" alt="" width="52" />
      </div>
      @if (state === gitAuthorizedEnum.SUCCESS) {
        <i class="pi pi-chevron-left color-grey-5"></i>
      }
      <div class="connection-line flex-grow-1 w-100" [class.error]="state === gitAuthorizedEnum.FAILED"></div>
      @if (state === gitAuthorizedEnum.SUCCESS) {
        <i class="pi pi-chevron-right color-grey-5"></i>
      }
      <div class="logo flex-shrink-0">
        <img ngSrc="assets/logos/logo-mogenius-logo-hochformat.svg" alt="" class="mogee" width="80" height="98" />
      </div>
    </div>

    <!-- LOADING -->
    @if (state === gitAuthorizedEnum.LOADING) {
      <div class="noti d-flex flex-column mt-4">
        <mo-spinner size="xs" tone="inherit" [debounce]="false" />
      </div>
    }

    <!-- SUCCESS -->
    <!-- <div class="noti d-flex flex-column mt-4" *ngIf="state === gitAuthorizedEnum.SUCCESS">
    <div *ngIf="data?.app" class="d-flex flex-column align-items-center mb-4 pb-3 color-deepteal">
      <span class="fw-bold mb-2">Your Gitlab user is already connected to {{ data?.app.name }}.</span>
      <span class="font-weight-regular">Select the account that you want to use with mogenius:</span>
    </div>

    <ul class="ng-star-inserted account-list">
      <li
        *ngFor="let item of data?.installations"
        class="d-flex ng-star-inserted border rounded px-3 w-100 mb-2 align-items-center"
        >
        <div>
          <img class="rounded-circle profile-image" style="width: 30px" [src]="item.account.avatar_url" />
        </div>
        <div>
          <label class="m-0 ms-2 color-deepteal">{{ item.account.login }}</label>
        </div>
        <div class="ms-auto pe-2">
          <button
            type="button"
            class="btn btn-text-link btn-small p-0 m-0 color-mogeniusblue"
            (click)="selectInstallation(item)"
            >
            Select
          </button>
        </div>
      </li>
    </ul>

    <button
      type="button"
      class="btn btn-text-link color-mogeniusblue font-weight-regular mt-4 mb-0"
      *ngIf="data?.installations.length > 0"
      (click)="openGithubNewInstallation(data?.callbackUrl)"
      >
      Authorize another GitHub organization
    </button>
  </div> -->

  <!-- FAILED -->
  @if (state === gitAuthorizedEnum.FAILED) {
    <div class="noti d-flex flex-column mt-4 mb-0">
      <i class="pi pi-times-circle text-danger state-icon" style="font-size: 36px" aria-hidden="true"></i>
      <p class="color-brick">Connection failed</p>
      @if (message === 'WRONG_GITLAB_USER') {
        <div
          class="d-flex flex-column align-items-center mb-4 pb-3 color-deepteal"
          >
          <span class="fw-bold mb-2">
            <i class="pi pi-exclamation-triangle me-2"></i>
            It seems you are logged into Gitlab with a different user.
          </span>
          <span class="font-weight-regular">Please sign in to GitLab with the appropriate user and try again.</span>
        </div>
      }
    </div>
  }
</div>
</div>
@if (state === gitAuthorizedEnum.SUCCESS || state === gitAuthorizedEnum.FAILED) {
  <div
    class="command color-deepteal font-size-regular d-flex justify-content-center align-items-center fw-bold mb-4"
    >
    <!--
    Please close this tab
    -->
    <a [href]="data?.callbackUrl.length > 0 ? data?.callbackUrl : fallbackUrl">
      <span>Back to mogenius</span>
      <i class="pi pi-chevron-right ms-2 font-size-xsmall mt-1"></i>
    </a>
  </div>
}
